module.exports = __webpack_public_path__ + "static/assets/19b5f6627a8e68005c44273cf1702ed5.png";